import { render } from "./DivinityView.vue?vue&type=template&id=5ffb4d4a"
import script from "./DivinityView.vue?vue&type=script&lang=js"
export * from "./DivinityView.vue?vue&type=script&lang=js"

import "./DivinityView.vue?vue&type=style&index=0&id=5ffb4d4a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__